import { create } from 'zustand';

const useSettingsModal = create<{ shown: boolean; show: () => void; hide: () => void }>()(
  (set) => ({
    shown: false,
    show: () => set({ shown: true }),
    hide: () => set({ shown: false }),
  }),
);

export default useSettingsModal;
